import FormDialog from "../../components/dialog/form/FormDialog.vue";
import SelectField from "../../components/fields/selectField/SelectField.vue";
import AutocompleteField from "../../components/fields/autocompleteField/AutocompleteField.vue";
import TextField from "../../components/fields/textField/TextField.vue";
import VisaoGeral from "../mapeamento-ferias/visao-geral/VisaoGeral.vue";
import { FeriasService } from "../../services/FeriasService";
import { MapeamentoFeriasService } from "../../services/MapeamentoFeriasService";
import { SnackBarModule } from "../../modules/SnackBarModule";
import { tipoPerfil } from "../../constants";
import { numeroBmMixin } from "../../mixins/numeroBmMixin";
import moment  from "moment";

export default {
  name: "MapeamentoFerias",

  components: {
    FormDialog,
    SelectField,
    TextField,
    VisaoGeral,
    AutocompleteField
  },

  mixins:[numeroBmMixin],

  data: () => ({
    dates: [],
    tituloPercentual: 'Percentual de militares com Férias (Aprovadas / Em Análise) da mesma unidade:',
    tituloPercentualTemp: '',
    pendentes: true,
    disabledLotacao: true,
    disabledUsuarios: true,
    solicitacoesAprovada: false,
    solicitacoesPendentes: false,
    solicitacoesAnalise: false,
    solicitacoesAnaliseMilitaresCivis: false,
    solicitacoesAprovadaMilitaresCivis: false,
    dataSelecionada: new Date().getFullYear() + "-01-01",
    headers: [{
        text: "Militares Com Pendência De Aprovação",
        value: "nome",
        align: 'left',
        sortable: false
      },
      {
        text: "Posto/Graduação",
        value: "descricao",
        align: 'left',
        sortable: false
      },
      {
        text: "Unidade/Lotação",
        value: "nome_abreviado",
        align: 'center',
        sortable: false
      },
      {
        text: "Periodo Férias",
        value: "periodo",
        align: 'left',
        sortable: false
      },
    ],
    headersAgendamento: 
    [
      { text: "Militares Sem Agendamento", value: "nome", align: 'left',sortable: false, width:"10px" },
      { text: "Nº BM", value: "numero", align: 'left',sortable: false, width:"10px" },
      { text: "Unidade/Lotação", value: "nome_abreviado", align: 'left',sortable: false, width:"10px" },
      { text: "Posto/Graduação", value: "descricao", align: 'left',sortable: false, width:"10px" }
    ],
    optionsFilter: {
      militares: [],
      unidade: [],
      lotacao: [],
      usuarios: [],
      visualizacao: [],
    },
    data: [],
    page: 1,
    pageCount: 0,
    totalItems: 10,
    dataAgendamento: [],
    pageAgendamento: 1,
    pageCountAgendamento: 0,
    totalItemsAgendamento: 10,
    metricas: {},
    metricasGeral: [],
    meses: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
    nomeMeses: {
      Dec: "Dezembro",
      Nov: "Novembro",
      Oct: "Outubro",
      Sep: "Setembro",
      Aug: "Agosto",
      Jul: "Julho",
      Jun: "Junho",
      May: "Maio",
      Apr: "Abril",
      Mar: "Março",
      Feb: "Fevereiro",
      Jan: "Janeiro"
    },
    attrs: [],
    totalMilitaresUnidade: 0,
    form: {},
    unidade:null,
    lotacao:null,
    anosDisponiveis: [],
    filter: {
      ano: 2025,
      militar:null,
      visualizacao:null,
      data:null,
      dataInicio:null,
      dataTermino:null
    }
  }),

  beforeMount() {
    this.listarMetricasUnidade();
    this.gerarListaAnos();
    this.filtraSolicitacoesPendentesInicial();
    this.listaSemAgendamento();
    this.listarFeriasPendentesAprovacao();
    this.getUnidadeItems();
    this.$forceUpdate();
    this.atualizavaloresiniciais();
  },

  mounted(){
    this.getMilitaresItems();
  },

  computed: {
    tituloSolicitacoesPendentes() {
      return 'Férias Pendentes de Aprovação <<' + this.$store.state.perfil_label.nome + '>>';
    }
  },

  watch: {
    page: function (val) {
      this.page = val;
      this.listarFeriasPendentesAprovacao();
    },
    pageAgendamento: function (val) {
      this.pageAgendamento = val;
      this.listaSemAgendamento();
    },
    pendentes: function (val) {
      if(val == "militares"){
        this.attrs = [];
        SnackBarModule("Preencha os campos de pesquisa", 'warning')
      }
    },
    unidade: async function(unidade){
      if (unidade) {
        this.getLotacoesItems(unidade);
      } else {
        this.disabledLotacao = true;
        this.unidade = null;
      }
      this.lotacao = null;
      this.disabledUsuarios = true;
      this.filter.usuarios = null;
    },
    lotacao: async function(lotacao){
      if (lotacao) {
        this.getMilitaresCivisItems(lotacao);
        this.disabledUsuarios = false;
      } else {
        this.disabledUsuarios = true;
        this.lotacao = null;
      }
      this.filter.usuarios = null;
    },
    solicitacoesAnalise: function (val) {
      if (val == 'solicitacao_analise') {
        this.solicitacoesPendentes = false;
        this.solicitacoesAprovada = false;
        this.solicitacoesAprovadaMilitaresCivis = false;
        this.tituloPercentualTemp = "Percentual de usuários com férias não aprovadas da mesma unidade:";
      }
    },
    solicitacoesAprovada: function (val) {
      if (val == 'solicitacao_aprovada') {
        this.solicitacoesPendentes = false;
        this.solicitacoesAnalise = false;
        this.solicitacoesAnaliseMilitaresCivis = false;
        this.tituloPercentualTemp = "Percentual de usuários com férias aprovadas da mesma unidade:";
      }
    },
    solicitacoesPendentes: function (val) {
      if (val == 'solicitacao_pendente') {
        this.solicitacoesAnalise = false;
        this.solicitacoesAnaliseMilitaresCivis = false;
        this.solicitacoesAprovada = false;
        this.solicitacoesAprovadaMilitaresCivis = false;
        this.tituloPercentualTemp = "Percentual de usuários com férias pendentes de aprovação da mesma unidade:";
      }
    },
  },

  methods: {
    atualizavaloresiniciais() {
      this.unidade = this.$store.state.user?.Unidade?.id || null;
      setTimeout(() => {
        this.lotacao = this.$store.state.user?.LotacaoId || null;
      }, 1500);
    },
    async getUnidadeItems() {
      const response = await FeriasService.getUnidade();
      this.optionsFilter.unidade = response.map((el) => {
        return {
          text: el.nome_abreviado,
          value: el.id,
        };
      });
      this.optionsFilter.unidade?.unshift({
        text: "Selecione",
        value: "",
      });
    },

    atualizarAno() {
      if (!this.filter.ano || !this.$refs.calendar) return;
      const novaData = new Date(`${this.filter.ano}-01-01T00:00:00`);
  
      if (this.$refs.calendar) {
        this.$refs.calendar.move(novaData);
      }
    },

    gerarListaAnos() {
      const anoAtual = new Date().getFullYear();
      this.anosDisponiveis = Array.from({ length: 10 }, (_, i) => anoAtual - i);
    },

    async getLotacoesItems(unidade) {
      const response = await FeriasService.getLotacaoByUnidade(unidade);

      this.optionsFilter.lotacao = response.map((el) => {
        return {
          text: el.nome,
          value: el.id,
        };
      });
      this.optionsFilter.lotacao?.unshift({
        text: "Selecione",
        value: "",
      });

      this.disabledLotacao = false;

    }, 

    async getMilitaresCivisItems(lotacao) {
      const response = await MapeamentoFeriasService.getUsuarios(lotacao);

      this.optionsFilter.usuarios = response.map((el) => {
        return {
          text: el.nome,
          value: el.id,
        };
      });
      this.optionsFilter.usuarios?.unshift({
        text: "Selecione",
        value: "",
      });
    }, 

    async listarFeriasPendentesAprovacao() {
      const response = await MapeamentoFeriasService.listarFeriasPendentesAprovacao(this.page);
      this.data = response.data
      this.pageCount = response.last_page;
      this.totalItems = response.total;
    },

    async listaSemAgendamento() {
      const formData = new FormData();
      formData.append('page', this.pageAgendamento);
      const response = await MapeamentoFeriasService.listaSemAgendamento(formData);
      this.dataAgendamento = response.data
      this.pageCountAgendamento = response.last_page;
      this.totalItemsAgendamento = response.total;
    },

    verificarSemAgendamento(){
      return this.$store.state.user.Perfis.indexOf(tipoPerfil['CHEFE_SEPLAN']) != -1;
    },

    verificarVisualizarUnidadeLotacao(){
      return this.$store.state.user.Perfis.indexOf(tipoPerfil['GERENCIA']) != -1 ;
    },

    async listarMapeamentoFerias() {
      const filter = new FormData();
    
      if(this.pendentes == 'militares'){
        if(this.filter.militar == null || this.filter.dataInicio == null || this.filter.dataTermino == null) {
          SnackBarModule("Preencha os campos de pesquisa", 'warning')
          return;
        }
    
        this.filter.visualizacao ? filter.append("id_sigrh", this.filter.militar ) : null; 
      }
    
      if(this.pendentes == 'ferias'){
        if (this.filter.dataInicio == null || this.filter.dataTermino == null) {
          SnackBarModule("Preencha os campos de pesquisa", 'warning')
          return;
        }
      }
    
      if(this.filter.dataInicio != null && this.filter.dataTermino != null){
        const calendar = this.$refs.calendar
        await calendar.move(this.filter.dataInicio);
        await calendar.move(1)
      }
    
      this.attrs = [];
    
      if (this.filter.dataInicio != null && this.filter.dataTermino != null) {
        const dataInicio = moment(this.filter.dataInicio);
        const dataTermino = moment(this.filter.dataTermino);
    
        if (dataInicio.isAfter(dataTermino)) {
          SnackBarModule("A data de início não pode ser maior que a data de término", 'warning');
          return;
        }
    
        filter.append("periodo_inicio", dataInicio.format("YYYY-MM-DD"));
        filter.append("periodo_termino", dataTermino.format("YYYY-MM-DD"));
      }
    
      this.filter.visualizacao ? filter.append("id_unidade", this.filter.visualizacao ) : null; 
      this.filter.militar ? filter.append("id_sigrh", this.filter.militar ) : null; 

    
      const response = await MapeamentoFeriasService.listarMapeamentoFerias(filter);
    
      this.metricasGeral = response.ferias
    
      if(this.filter.dataInicio != null){
        SnackBarModule(response.msg.text, response.msg.status);

      }
    
      let arrayMetricas = Object.values(response.ferias);

      const regexFormat = /[-\/]/g;  // eslint-disable-line
    
      let highlightConfiguracao =     {
        start: {
          fillMode: 'outline'
        },
        base: {
          fillMode: 'light'
        },
        end: {
          fillMode: 'outline'
        },
      };
    
      const listarFeriasMapemaento = this.pendentes == 'ferias' ? 1 : 0
    
      arrayMetricas.forEach(element => {
        if(element.aprovados.totalPessoas > listarFeriasMapemaento){
          element.aprovados.usuarios.forEach(user => {
            let inicio = user.inicio.split(regexFormat);
            let fim = user.fim.split(regexFormat);

    
            let atributo = {
              highlight: true,
              highlightConfiguracao,
              popover: {
                label: "Militar: "+user.nome+ " "+ user.inicio +" até "+user.fim,
                visibility: 'focus'
              },
              dates: {
                start: new Date(inicio[2], inicio[1]-1, inicio[0]),
                end: new Date(fim[2], fim[1]-1, fim[0])
              },

            }
            this.attrs.push(atributo);
          })
        }
      });
    },

    async filtraSolicitacoesEmAnalise() {
      const filter = new FormData();
    
      if (this.solicitacoesAnalise == false) {
         SnackBarModule("Preencha os campos de pesquisa", 'warning')
         return;
      }

      filter.append('tipo_filtro', this.solicitacoesAnalise);

      if (this.solicitacoesAnaliseMilitaresCivis) {
        filter.append('tipo_filtro_militar_civil', this.solicitacoesAnaliseMilitaresCivis);
      }
    
      if (this.filter.ano != null ) {
        filter.append("ano", this.filter.ano);
      }

      this.unidade ? filter.append("id_unidade", this.unidade): null;
      this.lotacao ? filter.append("id_lotacao", this.lotacao) : null;
      this.filter.usuarios ? filter.append("id_sigrh", this.filter.usuarios) : null;
    
      const response = await MapeamentoFeriasService.listarMapeamentoFerias(filter);
    
      this.metricasGeral = response.ferias

      let arrayMetricas = Object.values(response.ferias);

      const regexFormat = /[-\/]/g;  // eslint-disable-line
    
      let highlightConfiguracao =     {
        start: {
          fillMode: 'outline'
        },
        base: {
          fillMode: 'light'
        },
        end: {
          fillMode: 'outline'
        },
      };
    
      this.attrs = [];

      const listarFeriasMapemaento = this.pendentes == 'ferias' ? 1 : 0

      arrayMetricas.forEach(element => {

        if(element.analises.total > listarFeriasMapemaento){
          element.analises.usuarios.forEach(user => {
            let inicio = user.inicio.split(regexFormat);
            let fim = user.fim.split(regexFormat);
    
            let atributo = {
              highlight: 'yellow',
              highlightConfiguracao,
              popover: {
                label: "Militar com férias em análise: "+user.nome+ " "+ user.inicio +" até "+user.fim,
                visibility: 'focus'
              },
              dates: {
                start: new Date(inicio[2], inicio[1]-1, inicio[0]),
                end: new Date(fim[2], fim[1]-1, fim[0])
              },

            }
            this.attrs.push(atributo);
          })
        }
      });


      this.tituloPercentual = this.tituloPercentualTemp;
      this.listarMetricasUnidade('solicitacao_analise', this.solicitacoesAnaliseMilitaresCivis);
    },

    async filtraSolicitacoesPendentesInicial() {
      const filter = new FormData();

      filter.append('tipo_filtro', 'inicial');
    
      if (this.filter.ano != null ) {
        filter.append("ano", this.filter.ano);
      }

      this.unidade ? filter.append("id_unidade", this.unidade): null;
      this.lotacao ? filter.append("id_lotacao", this.lotacao) : null;
      this.filter.usuarios ? filter.append("id_sigrh", this.filter.usuarios) : null;
    
      const response = await MapeamentoFeriasService.listarMapeamentoFerias(filter);
    
      this.metricasGeral = response.ferias

      let arrayMetricas = Object.values(response.ferias);

      const regexFormat = /[-\/]/g;  // eslint-disable-line
    
      let highlightConfiguracao =     {
        start: {
          fillMode: 'outline'
        },
        base: {
          fillMode: 'light'
        },
        end: {
          fillMode: 'outline'
        },
      };
    
      this.attrs = [];

      const listarFeriasMapemaento = this.pendentes == 'ferias' ? 1 : 0

      arrayMetricas.forEach(element => {

        if(element.analises.total > listarFeriasMapemaento){
          element.analises.usuarios.forEach(user => {
            let inicio = user.inicio.split(regexFormat);
            let fim = user.fim.split(regexFormat);
    
            let atributo = {
              highlight: 'yellow',
              highlightConfiguracao,
              popover: {
                label: "Militar com férias em análise: "+user.nome+ " "+ user.inicio +" até "+user.fim,
                visibility: 'hover'
              },
              dates: {
                start: new Date(inicio[2], inicio[1]-1, inicio[0]),
                end: new Date(fim[2], fim[1]-1, fim[0])
              },

            }
            this.attrs.push(atributo);
          })
        }

        if(element.aprovados.totalPessoas > listarFeriasMapemaento){
          element.aprovados.usuarios.forEach(user => {
            let inicio = user.inicio.split(regexFormat);
            let fim = user.fim.split(regexFormat);
    
            let atributo = {
              highlight: true,
              highlightConfiguracao,
              popover: {
                label: "Militar com férias aprovada: "+user.nome+ " "+ user.inicio +" até "+user.fim,
                visibility: 'focus'
              },
              dates: {
                start: new Date(inicio[2], inicio[1]-1, inicio[0]),
                end: new Date(fim[2], fim[1]-1, fim[0])
              },

            }
            this.attrs.push(atributo);
          })
        }
      });

      this.tituloPercentual = this.tituloPercentualTemp;
      this.listarMetricasUnidade('inicial', this.solicitacoesAnaliseMilitaresCivis);
    },

    async filtraSolicitacoesAprovadas() {
      const filter = new FormData();
    
      if (this.solicitacoesAprovada == false) {
         SnackBarModule("Preencha os campos de pesquisa", 'warning')
         return;
      }

      filter.append('tipo_filtro', this.solicitacoesAprovada);

      if (this.solicitacoesAprovadaMilitaresCivis) {
        filter.append('tipo_filtro_militar_civil', this.solicitacoesAprovadaMilitaresCivis);
      }
    
      if (this.filter.ano != null ) {
        filter.append("ano", this.filter.ano);
      }

      this.unidade ? filter.append("id_unidade", this.unidade): null;
      this.lotacao ? filter.append("id_lotacao", this.lotacao) : null;
      this.filter.usuarios ? filter.append("id_sigrh", this.filter.usuarios) : null;
    
      const response = await MapeamentoFeriasService.listarMapeamentoFerias(filter);
    
      this.metricasGeral = response.ferias

      let arrayMetricas = Object.values(response.ferias);

      const regexFormat = /[-\/]/g;  // eslint-disable-line
    
      let highlightConfiguracao =     {
        start: {
          fillMode: 'outline'
        },
        base: {
          fillMode: 'light'
        },
        end: {
          fillMode: 'outline'
        },
      };
    
      this.attrs = [];

      const listarFeriasMapemaento = this.pendentes == 'ferias' ? 1 : 0

      arrayMetricas.forEach(element => {

        if(element.aprovados.totalPessoas > listarFeriasMapemaento){
          element.aprovados.usuarios.forEach(user => {
            let inicio = user.inicio.split(regexFormat);
            let fim = user.fim.split(regexFormat);
    
            let atributo = {
              highlight: true,
              highlightConfiguracao,
              popover: {
                label: "Militar com férias aprovada: "+user.nome+ " "+ user.inicio +" até "+user.fim,
                visibility: 'focus'
              },
              dates: {
                start: new Date(inicio[2], inicio[1]-1, inicio[0]),
                end: new Date(fim[2], fim[1]-1, fim[0])
              },

            }
            this.attrs.push(atributo);
          })
        }
      });

      this.tituloPercentual = this.tituloPercentualTemp;
      this.listarMetricasUnidade('solicitacao_aprovada', this.solicitacoesAprovadaMilitaresCivis);
    },

    async filtraSolicitacoesPendentes() {
      const filter = new FormData();
    
      if (this.solicitacoesPendentes == false) {
         SnackBarModule("Preencha os campos de pesquisa", 'warning')
         return;
      }

      filter.append('tipo_filtro', this.solicitacoesPendentes);
    
      if(this.filter.dataInicio != null && this.filter.dataTermino != null && this.filter.dataInicio != '' && this.filter.dataTermino != ''){
        const calendar = this.$refs.calendar
        await calendar.move(this.filter.dataInicio);
        await calendar.move(1)
      }
    
      if (this.filter.dataInicio != null && this.filter.dataTermino != null && this.filter.dataInicio != '' && this.filter.dataTermino != '') {
        const dataInicio = moment(this.filter.dataInicio);
        const dataTermino = moment(this.filter.dataTermino);
    
        if (dataInicio.isAfter(dataTermino)) {
          SnackBarModule("A data de início não pode ser maior que a data de término", 'warning');
          return;
        }
    
        filter.append("periodo_inicio", dataInicio.format("YYYY-MM-DD"));
        filter.append("periodo_termino", dataTermino.format("YYYY-MM-DD"));
      }

      this.unidade ? filter.append("id_unidade", this.unidade): null;
      this.lotacao ? filter.append("id_lotacao", this.lotacao) : null;
      this.filter.usuarios ? filter.append("id_sigrh", this.filter.usuarios) : null;
    
      const response = await MapeamentoFeriasService.listarMapeamentoFerias(filter);
    
      this.metricasGeral = response.ferias

      let arrayMetricas = Object.values(response.ferias);

      const regexFormat = /[-\/]/g;  // eslint-disable-line
    
      let highlightConfiguracao =     {
        start: {
          fillMode: 'outline'
        },
        base: {
          fillMode: 'light'
        },
        end: {
          fillMode: 'outline'
        },
      };
    
      this.attrs = [];

      const listarFeriasMapemaento = this.pendentes == 'ferias' ? 1 : 0

      arrayMetricas.forEach(element => {

        if(element.pendentes.total > listarFeriasMapemaento){
          element.pendentes.usuarios.forEach(user => {
            let inicio = user.inicio.split(regexFormat);
            let fim = user.fim.split(regexFormat);
    
            let atributo = {
              highlight: 'orange',
              highlightConfiguracao,
              popover: {
                label: "Militar com férias pendentes de aprovação: "+user.nome+ " "+ user.inicio +" até "+user.fim,
                visibility: 'focus'
              },
              dates: {
                start: new Date(inicio[2], inicio[1]-1, inicio[0]),
                end: new Date(fim[2], fim[1]-1, fim[0])
              },

            }
            this.attrs.push(atributo);
          })
        }
      });

      this.tituloPercentual = this.tituloPercentualTemp;
      this.listarMetricasUnidade('solicitacao_pendente');
    },

    pesquisarFerias () {
      if (this.solicitacoesAnalise) {
        this.filtraSolicitacoesEmAnalise();
      }

      else if (this.solicitacoesAprovada) {
        this.filtraSolicitacoesAprovadas();
      }

      else if (this.solicitacoesPendentes) {
        this.filtraSolicitacoesPendentes();
      } 

      else {
        this.filtraSolicitacoesPendentesInicial();
      }

      this.atualizarAno();
    },

    async listarMetricasUnidade(filtro = null, subfiltro = null) {
      const filter = new FormData();  

      this.unidade ? filter.append("id_unidade", this.unidade): null;
      this.lotacao ? filter.append("id_lotacao", this.lotacao) : null;
      this.filter.usuarios ? filter.append("id_sigrh", this.filter.usuarios) : null;

      if (this.filter.ano != null) {
        filter.append("ano", this.filter.ano);
      }

      if (filtro) {
        filter.append("tipo_filtro", filtro);
      }

      if (subfiltro) {
        filter.append("tipo_filtro_militar_civil", subfiltro);
      }

      const response = await MapeamentoFeriasService.listarMetricasUnidade(filter);
      let texto;

      if (response?.especifico) {
        texto = "Total de usuários pendentes de aprovação: ";
      } else {
        texto = "Total de usuários na mesma unidade: ";
      }

      this.totalMilitaresUnidade = texto + response.totalMilitaresUnidade;
      this.metricas = response.ferias;
    },

    async getMilitaresItems() {
      const filter = new FormData();
      this.filter.data ? filter.append("periodo[ano]", moment(this.filter.data).format("YYYY") ) : null;
      this.filter.data ? filter.append("periodo[mes]", moment(this.filter.data).format("MM") ) : null;      
      this.filter.visualizacao ? filter.append("id_unidade", this.filter.visualizacao ) : null;      

      const response = await FeriasService.getMilitaresFeriasAgendada(filter);
      this.optionsFilter.militares = response.map((el) => {
        return {
          text: el.nome,
          value: el.id,
        };
      });
      this.optionsFilter.militares?.unshift({
        text: "Selecione",
        value: null,
      });
    },

    async getFerias() {
      if(this.filter.data == null && this.filter.militar == null){
        SnackBarModule("Selecione o campo data e o campo militar", "error");
        return;
      }

      const filter = this.prepareFormFilter();

      const response = await FeriasService.obterFerias(filter);

      let arrayMetricas = Object.values(response.data);

      const regexFormat = /[-\/]/g;  // eslint-disable-line
      let highlight =     {
        start: {
          fillMode: 'outline'
        },
        base: {
          fillMode: 'light'
        },
        end: {
          fillMode: 'outline'
        },
      };

      this.attrs = [];

      arrayMetricas.forEach(element => {
        let inicio = element.dataIni.split(regexFormat);
        let fim = element.dataFin.split(regexFormat);

        let atributo = {
          highlight,
          popover: {
            label: "Militar: "+element.nome+ " "+ element.dataIni +" até "+element.dataFin,
            visibility: 'focus'
          },
          dates: {
            start: new Date(inicio[2], inicio[1]-1, inicio[1]),
            end: new Date(fim[2], fim[1]-1, fim[1])
          },

        }
        this.attrs.push(atributo);
      });
    },

    async prepareFormFilter() {
      const filter = new FormData();

      filter.append("page", this.page);
      this.filter.militar ? filter.append("id_sigrh", this.filter.militar) : null;
      this.filter.data ? filter.append("ano", moment(this.filter.data).format("YYYY") ) : null;
      this.filter.data ? filter.append("mes", moment(this.filter.data).format("MM") ) : null;
      filter.append('status', 3);

      const calendar = this.$refs.calendar
      await calendar.move(this.filter.data)

      return filter;
    },

    showVisaoGeral() {
      this.pendentes = false;
    },

    limparFiltros() {
      this.solicitacoesAprovada = false;
      this.solicitacoesPendentes = false;
      this.solicitacoesAnalise = false;
      this.solicitacoesAnaliseMilitaresCivis = false;
      this.solicitacoesAprovadaMilitaresCivis = false;
      this.filter.militar = null;
      this.filter.visualizacao = null;
      this.filter.data = null;
      this.filter.dataInicio = null;
      this.filter.dataTermino = null;
      this.lotacao = null;
      this.unidade = null;
      this.disabledLotacao = true;
      this.listarMapeamentoFerias();
      this.listarMetricasUnidade();
    }

  },
};